import React from 'react';
import styled from 'styled-components';

import Loading from './Loading';
import MaintenanceVendorForm from './MaintenanceVendorForm/MaintenanceVendorForm';
import AcknowledgeTicketSuccess from './AcknowledgeTicket/AcknowledgeTicketSuccess';
import AcknowledgeTicketError from './AcknowledgeTicket/AcknowledgeTicketSuccess';
import UpdateTicketSuccess from './UpdateTicket/UpdateTicketSuccess';
import UpdateTicketError from './UpdateTicket/UpdateTicketError';

export const PAGE_STATES = {
  form: 'form',
  loading: 'loading',
  updateTicketSuccess: 'updateTicketSuccess',
  acknowledgeTicketSuccess: 'acknowledgeTicketSuccess',
  updateTicketError: 'updateTicketError',
  acknowledgeTicketError: 'acknowledgeTicketError',
};

const MarginTop = styled.div`
  margin-top: 15px;
`;

export const SwitchPageStates = ({
  pageState,
  handleRetry,
  handleAcknowledge,
  openForm,
  openFormAfterUpdate,
  maintenanceTicket,
  updateTicket,
}) => {
  if (pageState === PAGE_STATES.form) {
    return <MaintenanceVendorForm {...maintenanceTicket} updateTicket={updateTicket} />;
  } else if (pageState === PAGE_STATES.loading) {
    return (
      <MarginTop>
        <Loading />
      </MarginTop>
    );
  } else if (pageState === PAGE_STATES.updateTicketSuccess) {
    return (
      <MarginTop>
        <UpdateTicketSuccess onClick={openFormAfterUpdate} />
      </MarginTop>
    );
  } else if (pageState === PAGE_STATES.acknowledgeTicketSuccess) {
    return (
      <MarginTop>
        <AcknowledgeTicketSuccess onClick={openForm} />
      </MarginTop>
    );
  } else if (pageState === PAGE_STATES.updateTicketError) {
    return (
      <MarginTop>
        <UpdateTicketError onClick={handleRetry} />
      </MarginTop>
    );
  } else if (pageState === PAGE_STATES.acknowledgeTicketError) {
    return (
      <MarginTop>
        <AcknowledgeTicketError onClick={handleAcknowledge} />
      </MarginTop>
    );
  }
};
